import { TextFieldProps } from '@mui/material'
import { DateTimeRangePicker } from '@mui/x-date-pickers-pro'
import { DateTime } from 'luxon'
import { useIntl } from 'react-intl'
import { DateTimeRangeStringValues, StateControl } from '.'

export type DateTimeRangePickerSearchFieldProps = {
  labels?: {
    start?: string
    end?: string
  }
  stateControl: StateControl<DateTimeRangeStringValues>
  textFieldProps?: TextFieldProps
}

const DateTimeRangePickerSearchField = (
  props: DateTimeRangePickerSearchFieldProps,
) => {
  const [value, setValue] = props.stateControl
  const start = value.start ? DateTime.fromISO(value.start) : null
  const end = value.end ? DateTime.fromISO(value.end) : null

  const intl = useIntl()
  return (
    <DateTimeRangePicker
      defaultValue={[start, end]}
      slotProps={{
        textField: {
          size: 'small',
          sx: {
            minWidth: '8rem',
          },
          ...props.textFieldProps,
        },
      }}
      sx={{
        width: '100%',
      }}
      onChange={(event) => {
        setValue({
          start: event[0]?.toISO() ?? null,
          end: event[1]?.toISO() ?? null,
        })
      }}
      localeText={{
        start:
          props.labels?.start ??
          intl.formatMessage({ id: 'dateTimeRangePicker.labels.start' }),
        end:
          props.labels?.end ??
          intl.formatMessage({ id: 'dateTimeRangePicker.labels.end' }),
      }}
    />
  )
}

export default DateTimeRangePickerSearchField
